import React from 'react'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import CertificateHeader from '../containers/CertificateHeader/CertificateHeader.container'
import CertificateHeadingSectionContainer from '../containers/CertificateHeadingSection/CertificateHeadingSection.container'
import EnrollmentCertificateSectionContainer from '../containers/EnrollmentCertificateSection/EnrollmentCertificateSection.container'
import FooterSectionContainer from '../containers/CertificateFooterSection/CertificateFooterSection.container'
import { Root } from './EnrollmentCertificate.styles'

/**
 * The EnrollmentCertificate' page.
 */
const EnrollmentCertificate = () => {
  return (
    <AuthorizationProviderContainer>
      <BrandLayout featured={<CertificateHeadingSectionContainer />} header={<CertificateHeader />}>
        <Root>
          <EnrollmentCertificateSectionContainer />
          <FooterSectionContainer />
        </Root>
      </BrandLayout>
    </AuthorizationProviderContainer>
  )
}

export default EnrollmentCertificate
